// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/video-carousel/video-carousel.component.scss
// module id = 558
// module chunks = 0